import React, {useState, useEffect, useRef} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {
  apollo_useStyles,
  apollo_useRowStyles,
  options_matchtype,
  valueToOption,
} from "../../atom/Apollo_styles";
import {ApolloAuthorization} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";

import Typography from "@material-ui/core/Typography";
import {Link, useHistory, useParams} from "react-router-dom";
import Select from 'react-select';

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Divider from "@material-ui/core/Divider";

import Fab from "@material-ui/core/Fab";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';

import {ApolloContext} from "../../atom/Apollo_Context";
import axios from "axios";
import moment from "moment";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {Attention, DeleteButton} from "../../molecule/Apollo_Button";

import {
  Event,
  Audience,
  UrlPattern,
  AudienceActiveUpdateRequest,
} from "./HeraModel"

import {heraaudiences_path, hera_audiences_path, hera_events_path} from "../../atom/Apollo_links"

import {ApolloEventRecord, ItemList, LogData} from "../../atom/Apollo_EventRecord";
import { options_state_audience } from "./common/CommonConst";
import { ApiResponse, ApolloAxios, getResultType, isSuccessApi } from "../../atom/Apollo_ApiRequest3";
import ActiveDialog from "./common/ActiveDialog";

// エラーメッセージ
const ERROR_MESSAGE = [
  "データの取得に失敗しました",
];
// 警告メッセージ
const WARNING_MESSAGE = [
  "有効可能上限数を超えてしまうため、ステータスを「有効」にすることができません。他の有効なオーディエンスのステータスを「無効」にしてから、再度設定してください。",
]

const valueToLabel = function (value: any, options: Array<{ value: any; label: string }>): string {
  let option = options.find(option => option.value === value)
  if (!option) {
    return ""
  } else {
    return option.label
  }
}

function Row(props: { row: UrlPattern }) {
  const {row} = props;
  const classes = apollo_useRowStyles();
  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell align="left">{row.pattern}</TableCell>
        <TableCell align="left">{valueToLabel(row.matchType, options_matchtype)}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const HeraAudienceDetail: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  const {state} = React.useContext(ApolloContext);
  const trackerId = state.current.trackerId

  // 0: 新規　、　id：編集
  const {audienceId} = useParams<{ audienceId: string; }>();

  const initAudience: Audience = {
    ID: 0,
    name: "",
    isActive: true,
    condition: {
      eventID: 0,
      urlTarget: true,
      urlPatterns: [],
    },
    audienceSpan: 0
  }

  const initEvent: Event = {
    ID: 0,
    name: "",
    latestRecord: "",
  }

  const [audience, setAudience] = useState<Audience>(initAudience)
  const [event, setEvent] = useState<Event>(initEvent)
  const beforeAudience = useRef<Audience>(initAudience)

  const {data, setmsg} = React.useContext(ApolloMessage);
  const processing = useRef(false);
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    const fetchAudience = async () => {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: true
        }
      })
      const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_audiences_path}/${trackerId}/${audienceId}`
      await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      }).then((response) => {
        if (response.data.resultcode === 0) {
          setAudience(response.data.result);
          beforeAudience.current = response.data.result;
        } else {
          console.log(response.data.message);
          const errMsg = response.data.message ? response.data.message : ERROR_MESSAGE[0];
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: errMsg
            }
          });
        }
      })
        .catch((error) => {
          const errMsg = error.message ? error.message : ERROR_MESSAGE[0];
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: errMsg
            }
          });
        })
        .finally(() => {
          setmsg({
            type: "loading",
            payload: {
              ...data,
              loading: false
            }
          })
        })
    }
    fetchAudience();
  }, [])

  useEffect(() => {
    const fetchEvent = async () => {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: true
        }
      })
      const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_events_path}/${trackerId}/${audience.condition.eventID}`
      await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      }).then((response) => {
        if (response.data.resultcode === 0) {
          setEvent(response.data.result);
        } else {
          console.log(response.data.message);
          const errMsg = response.data.message ? response.data.message : ERROR_MESSAGE[0];
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: errMsg
            }
          });
        }
      })
        .catch(err => { 
          const errMsg = err.message ? err.message : ERROR_MESSAGE[0];
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: errMsg
            }
          });
        })
        .finally(() => {
          setmsg({
            type: "loading",
            payload: {
              ...data,
              loading: false
            }
          })
        })
    }
    if (audience.ID !== 0) {
      fetchEvent()
    }
  }, [audience])

  const products = [
    {name: 'トラッカーID', desc: 'tracker id', value: trackerId},
    {name: 'オーディエンスID', desc: 'audience id', value: audience.ID},
    {name: 'オーディエンス名', desc: 'audience name', value: audience.name},
    {name: 'ステータス', desc: 'isActive name', value: audience.isActive},
    {name: '有効期間', desc: 'audienceSpan', value: `${audience.audienceSpan}日`},
    {name: 'イベント名', desc: 'イベント名称', value: event.name},
  ];

  const handleDelete = async () => {
    if (processing.current) return;
    processing.current = true;
    let isSuccess = false;

    // 実行時ログ
    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken ,
      accountGroupID : state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID : state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "オーディエンス詳細画面",
      category: "オーディエンス",
      actionType: "削除",
      targetID: audience.ID + "",
      targetName: audience.name,
      itemList: [],
    }
    ApolloEventRecord(executionLog);

    const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_audiences_path}/${trackerId}/${audienceId}`
    await axios.delete(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    }).then(() => {
      isSuccess = true;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: "削除に成功しました"
        }
      });
    }).catch(() => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "削除に失敗しました"
        }
      });
    }).finally(() => {
      // 実行結果ログ
      const resultLog: LogData = {
        ...executionLog,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "result",
        result: isSuccess? "成功" : "失敗",
      }
      ApolloEventRecord(resultLog);

      processing.current = false;

      if (isSuccess) {
        const url = `${heraaudiences_path}`
        history.push(url);
      }
    });
  };

  const handleChangeStatus = (event: any) => {
    setAudience({
      ...audience,
      isActive: event.value,
    })
  };

  const handleSaveStatus = async () => {
    if (beforeAudience.current.isActive && !audience.isActive) {
      setOpen(true);
    } else {
      await handleSaveStatusExecute();
    }
  };

  const handleSaveStatusExecute = async () => {
    if (processing.current) return;
    processing.current = true;
    let isSuccess = false;

    let itemList: ItemList[] = [
      {
        key: "ステータス",
        beforeValue: valueToOption(beforeAudience.current.isActive, options_state_audience).label,
        afterValue: valueToOption(audience.isActive, options_state_audience).label,
      },
    ]

    // 実行時ログ
    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken ,
      accountGroupID : state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID : state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "オーディエンス詳細画面",
      category: "オーディエンス",
      actionType: "更新",
      targetID: audienceId,
      targetName: audience.name,
      itemList: itemList,
    }
    ApolloEventRecord(executionLog);

    const url = `${hera_audiences_path}/${trackerId}/${audienceId}/active`
    const apiBody: AudienceActiveUpdateRequest = {
      isActive: audience.isActive,
    }

    await ApolloAxios.patch(url, apiBody).then(response => {
      const res: ApiResponse = response.data
      if (!isSuccessApi(res.resultCode)) {
        const type: string = response?.data?.message === "有効可能上限数エラー" ? "warning" : getResultType(res.resultCode)
        const message: string = response?.data?.message === "有効可能上限数エラー" ? WARNING_MESSAGE[0] : `ステータス更新に失敗しました。${res?.message ?? ""}`
        return Promise.reject({
          open: true,
          type: type,
          errmsg: message,
        });
      } else {
        isSuccess = true;
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: "ステータス更新に成功しました。"
          }
        });
      }
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      const resultLog: LogData = {
        ...executionLog,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "result",
        result: isSuccess? "成功" : "失敗",
      }
      ApolloEventRecord(resultLog);

      processing.current = false;
      if (isSuccess) {
        const url = `${heraaudiences_path}`
        history.push(url);
      }
    });
  }

  const handelGoback = () => {
    const url = `${heraaudiences_path}`
    history.push(url);
  };

  const attention: Attention = {
    message: "※削除後はサイト来訪ログなどの蓄積停止となりますのでご注意ください",
    style: {color: "red"}
  }

  return (
    <GenericTemplate title="">
      <ApolloBreadcrumbs bread_no={51} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                         platform={""}/>
      <CustomizedSnackbars/>
      <ApolloAuthorization role={10}>
        <Tooltip title="オーディエンス削除" placement="top">
          <Fab color="primary" aria-label="del" className={classes.fab}>
            <DeleteButton handleDelete={handleDelete} title="オーディエンス削除" text={`${audience.name}を削除しますか？`} attention={attention}/>
          </Fab>
        </Tooltip>
      </ApolloAuthorization>
      <React.Fragment>
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Box my={3}>
              <Grid container spacing={3}>
                {products.map((product, index) => (
                  <React.Fragment key={index}>
                    <Grid item xs={6}>
                      <Typography>{product.name}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      {(() => {
                        if (product.name === "ステータス") {
                          return (
                            <Select
                              id="isActive"
                              name="isActive"
                              options={options_state_audience}
                              menuPosition="fixed"
                              defaultValue={options_state_audience[0]}
                              value={options_state_audience.find((v) => v.value === audience.isActive)}
                              onChange={handleChangeStatus}
                            />
                          )
                        } else {
                          return (<Typography>{product.value}</Typography>)
                        }
                      })()}
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Box>
            <Typography variant="subtitle1" gutterBottom>
              測定条件
            </Typography>
            <TableContainer component={Paper} square variant="outlined">
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">指定URL</TableCell>
                    <TableCell align="left">URLパターン</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {audience?.condition?.urlPatterns?.map((row, index: number) => (
                    <Row key={index} row={row}/>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
          <CardActions className={classes.cardaction}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveStatus}
              className={classes.button}
            >
              ステータス更新
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handelGoback}
              className={classes.button}
            >
              戻る
            </Button>
          </CardActions>
        </Card>
      </React.Fragment>

      <ActiveDialog
        open={open}
        type={"audience"}
        name={audience.name}
        handleSave={handleSaveStatusExecute}
        handleClose={() => {setOpen(false)}}
      />
    </GenericTemplate>
  );
};

export default HeraAudienceDetail;
